export const ID = 'id';
export const NAME = 'name';

export const APPLICATION = 'appId';
export const PROTOTYPE_ID = 'prototypeId';
export const DESCRIPTION = 'description';

export const PURCHASE_DATA = 'purchaseData';
export const TRIGGER = 'trigger';
export const PARAMETERS = 'parameters';
